module.exports = __webpack_public_path__ + "/img/saasu-icon.56dc58e0d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/saasu-icon.svg
// module id = 1396
// module chunks = 0